window.filedroparea =
{
    init: function ()
    {
        var dropAreas = document.querySelectorAll(".file-drop-area");

        if (!dropAreas)
            return;

        dropAreas.forEach(dropArea =>
        {
            var input = dropArea.querySelector(".file-drop-input");
            var message = dropArea.querySelector(".file-drop-message");
            var icon = dropArea.querySelector(".file-drop-icon");
            var button = dropArea.querySelector(".file-drop-btn");

            button.addEventListener("click", () =>
            {
                input.click();
            });

            input.addEventListener("change", (event) =>
            {
                if (!input.files || !input.files[0])
                    return;

                var reader = new FileReader();
                reader.onload = function (e)
                {
                    var target = e.target.result;

                    var fileName = input.files[0].name;

                    message.innerHTML = fileName;

                    if (target.startsWith("data:image"))
                    {
                        var image = new Image;
                        image.src = target;
                        image.onload = function ()
                        {
                            icon.className = "file-drop-preview img-thumbnail rounded";
                            icon.innerHTML = '<img src="' + image.src + '" alt="' + fileName + '">';
                        }
                    }
                    else if (e.startsWith("data:video"))
                    {
                        icon.innerHTML = "";
                        icon.className = "";
                    }
                };

                reader.readAsDataURL(input.files[0]);
            });
        });
    }
};